import script from "./InputMonth.vue?vue&type=script&setup=true&lang=js"
export * from "./InputMonth.vue?vue&type=script&setup=true&lang=js"

import "./InputMonth.vue?vue&type=style&index=0&id=66d61706&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d61706"]])

export default __exports__